import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useUserAccounts } from '../hooks/useUserAccounts';
import { SpinnerWithText } from '../components/LoadingSpinner';

function AccountRequiredRoute({ children }) {
  const { isAuthenticated, loading: authLoading } = useAuth();
  const { hasAccounts, loading: accountsLoading } = useUserAccounts();

  // 如果還在載入中，顯示載入畫面
  if (authLoading || accountsLoading) {
    return (
      <div style={{
        minHeight: '100vh',
        background: 'white',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <SpinnerWithText
          text="檢查帳號狀態..."
          size="48px"
          color="#667eea"
          textColor="#9ca3af"
          direction="vertical"
        />
      </div>
    );
  }

  // 如果未登入，導向登入頁面
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // 如果已登入但沒有綁定帳號，顯示提示訊息或空白頁面
  // 不自動導航到 /welcome，讓登入流程或新增帳號流程處理
  if (!hasAccounts) {
    return (
      <div style={{
        minHeight: '100vh',
        background: 'white',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        gap: '16px'
      }}>
        <SpinnerWithText
          text="請先綁定社群媒體帳號..."
          size="48px"
          color="#667eea"
          textColor="#9ca3af"
          direction="vertical"
        />
        <p style={{ color: '#9ca3af', fontSize: '14px' }}>
          請從設定頁面新增帳號，或<a href="/onboarding/step1" style={{ color: '#667eea' }}>前往連接帳號頁面</a>
        </p>
      </div>
    );
  }

  // 如果已登入且有綁定帳號，顯示目標頁面
  return children;
}

export default AccountRequiredRoute;